import React, { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { DialogProvider } from "@/components/site/DialogProvider";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import MenuSection from "@/components/site/MenuSection";
import Signature from "@/components/site/Signature";
import Gallery from "@/components/site/Gallery";
import Locations from "@/components/site/Locations";
import Features from "@/components/site/Features";
import Spaces from "@/components/site/Spaces";
import Reviews from "@/components/site/Reviews";
import Offers from "@/components/site/Offers";
import Events from "@/components/site/Events";
import Franchise from "@/components/site/Franchise";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

function useLenis() {
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true, lerp: 0.09 });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
  }, []);
}

function App() {
  useLenis();
  return (
    <div className="App bg-[#F5F2EB]">
      <div className="noise-overlay" aria-hidden />
      <DialogProvider>
        <Header />
        <main>
          <Hero />
          <Marquee />
          <About />
          <MenuSection />
          <Signature />
          <Gallery />
          <Locations />
          <Features />
          <Spaces />
          <Reviews />
          <Offers />
          <Events />
          <Franchise />
          <Contact />
        </main>
        <Footer />
      </DialogProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
